<script setup lang="ts">
  import { DocumentViewInfo as DocumentInfo } from '@/features/Document';
  import type { InfoDocumento } from '@/shared/lib';
  import { ChangelogSection } from '@/shared/ui';

  defineProps<{
    changelog: string[];
    documentId: string;
    info: InfoDocumento[];
  }>();
</script>

<template>
  <div class="approval-details-view divide-y divide-gray-02">
    <div class="p-6">
      <DocumentInfo
        :info="info"
        :document-id="documentId"
      />
    </div>

    <ChangelogSection :changelog="changelog" />
  </div>
</template>
